import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { ExperimentStore, PageStore } from 'bernie-plugin-mobx';

import { TRIP_OVERVIEW_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { TemplateName } from 'constants/template-name';
import { AbstractTemplateController } from 'controllers/abstract-template-controller';

/**
 * /trips
 * /trips/75555544443333222111
 */

export class TripOverviewController extends AbstractTemplateController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public readonly pageId = 'page.Trip.Overview,U,80';
  public readonly path = '/trips/:tripViewId([a-z0-z-]+|hcom_eid_[^/]+)';
  public readonly routeName = 'trip-overview';
  public readonly templateName = TemplateName.TRIP_OVERVIEW;
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => {
      import(/* webpackPrefetch: true */ '../views/trip-item-details-view');

      return import(/* webpackChunkName: "trip-details" */ 'views/trip-overview-view');
    }
  );

  public readonly pageName = 'page.Trip.Overview';
  public readonly clickstreamPageName = 'Trip Overview';

  public isTemplatingEnabled(experimentStore: ExperimentStore): boolean {
    return experimentStore.exposures['Trips_Overview_Template_Renderer_Web']?.bucket === 1;
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_OVERVIEW_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-overview-controller'
    });

    return Promise.resolve();
  }
}
